import { fromJS } from 'immutable';
import { createReducerBySpec } from '@Utils/Redux/reducerFactory';
import { setFullTextDocumentIdType } from './HopintoConstants';

export const initialState = fromJS({
  fullTextDocumentId: null,
});

export const spec = {
  [setFullTextDocumentIdType]: (state, action) => {
    const { fullTextDocumentId } = action.payload;

    return state.set('fullTextDocumentId', fullTextDocumentId);
  },
};

const hopintoReducer = createReducerBySpec(spec, initialState);

export default hopintoReducer;
